/* ps-brand-caption.js -- Primostore. Authored in the hub, not by Impulse.
   Inserts a "Brand: X" line directly above the PDP title. Started as the
   design system's literal "Brand caption" spec (bare uppercase brand name);
   Abdo, 2026-08-18, after seeing it live: "i want it more larger and saying
   brand primanova" -- so it now reads "Brand: PrimaNova", matching his own
   Amazon reference screenshot ("Brand: GRAVIN"), not the book's bare caption.
   The value comes from snippets/product-template-variables.liquid's hidden
   #ps-brand-data span, not styled there on purpose -- this file owns the
   visible element so a theme update to the Impulse-owned title markup cannot
   silently duplicate or misplace it. */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") { fn(); }
    else { document.addEventListener("DOMContentLoaded", fn); }
  }

  ready(function () {
    var data = document.getElementById("ps-brand-data");
    var title = document.querySelector(".product-single__title");
    if (!data || !title || document.querySelector(".ps-brand-caption")) { return; }

    var brand = data.textContent.trim();
    if (!brand) { return; }

    var caption = document.createElement("p");
    caption.className = "ps-brand-caption";
    caption.textContent = "Brand: " + brand;
    title.insertAdjacentElement("beforebegin", caption);
  });
})();
